<template>
  <LoadingWrapper :state="status">
    <div class="bg-surface flex w-full items-center justify-center px-4">
      <div
        class="bg-surface-container-lowest rounded-extra-large flex w-full max-w-2xl flex-col gap-2 p-6 md:p-8"
      >
        <div class="relative mx-auto mb-6 h-32 w-32">
          <BaseShape shape="slanted" class="text-primary-container h-full w-full" />
          <BaseIcon
            size="48"
            class="text-on-primary-container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >balance</BaseIcon
          >
        </div>
        <h2 class="text-display-small">{{ data.title }}</h2>
        <span
          class="text-body-small text-on-surface-variant bg-surface mr-auto inline-block rounded-full px-2 py-0.5"
          >Version {{ data.version }}</span
        >
        <div class="rounded-medium bg-surface max-h-[20vh] overflow-y-auto p-3">
          <div class="text-body-medium text-on-surface-variant w-full" v-html="data.content" />
        </div>
        <div v-if="data.link" class="-mx-3 w-full">
          <a :href="data.link" target="_blank">
            <BaseTextButton trailing-icon="open_in_new" size="S" class="text-on-surface-variant!">
              {{ $t('common.read-more') }}
            </BaseTextButton>
          </a>
        </div>
        <div class="mt-6 flex flex-row items-center justify-between gap-4">
          <p v-if="user.specialTerms?.acceptedAt" class="text-body-medium text-on-surface-variant">
            Akzeptiert am: {{ useDisplayDate(user.specialTerms?.acceptedAt) }}
          </p>
        </div>
      </div>
    </div>
  </LoadingWrapper>
</template>
<script setup lang="ts">
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useSpecialTerms } from '../composables/use-special-terms'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { useUserStore } from '@/stores/user.store'
  import { useDisplayDate } from '@/core/composables/use-display-date'

  const { data, status } = useSpecialTerms()
  const { user } = useUserStore()
</script>
